import {
  CONTINENTAL_CUP_MAIN,
  CONTINENTAL_CUP_MAIN_PLAY_OFF,
  CONTINENTAL_CUP_MINOR,
  CONTINENTAL_CUP_MINOR_PLAY_OFF,
  CONTINENTAL_CUP_THIRD,
  CONTINENTAL_CUP_THIRD_PLAY_OFF,
  RELEGATION,
  RELEGATION_PLAY_OUT,
  PROMOTION,
  PROMOTION_PLAY_OFF,
  CompetitionClassification,
} from '../typings/competition';

export const UEFACompetitionQualificationArray = [
  'Champions_League',
  'Champions_League_Qualifying',
  'Europa_Cup',
  'Conference_League_Qualifying',
  'Relegation',
  'Promotion',
  'Play_Off',
  'Europa_Cup_Qualifying',
  'Conference_League',
  'Play_Out',
  'uefa-promotion',
  'uefa-playoff',
  'uefa-elimination',
] as const;

export type UEFACompetitionQualification = (typeof UEFACompetitionQualificationArray)[number];
export const isUEFACompetitionQualification = (x: any): x is UEFACompetitionQualification =>
  UEFACompetitionQualificationArray.includes(x);

export type nullableUEFACompetitionQualification = UEFACompetitionQualification | null | undefined | '';

// BE DATA
const UEFA_CHAMPIONS_LEAGUE: UEFACompetitionQualification = 'Champions_League';
const UEFA_CHAMPIONS_LEAGUE_QUALIFYING: UEFACompetitionQualification = 'Champions_League_Qualifying';
const UEFA_EUROPA_LEAGUE: UEFACompetitionQualification = 'Europa_Cup';
const UEFA_EUROPA_LEAGUE_QUALIFYING: UEFACompetitionQualification = 'Europa_Cup_Qualifying';
const UEFA_CONFERENCE_LEAGUE: UEFACompetitionQualification = 'Conference_League';
const UEFA_CONFERENCE_LEAGUE_QUALIFYING: UEFACompetitionQualification = 'Conference_League_Qualifying';
const IN_RELEGATION: UEFACompetitionQualification = 'Relegation';
const IN_PROMOTION: UEFACompetitionQualification = 'Promotion';
const IN_PLAY_OFF: UEFACompetitionQualification = 'Play_Off';
const IN_PLAY_OUT: UEFACompetitionQualification = 'Play_Out';

export const uefaCompetitionQualificationList: UEFACompetitionQualification[] = [
  UEFA_CHAMPIONS_LEAGUE,
  UEFA_CHAMPIONS_LEAGUE_QUALIFYING,
  UEFA_EUROPA_LEAGUE,
  UEFA_EUROPA_LEAGUE_QUALIFYING,
  UEFA_CONFERENCE_LEAGUE,
  UEFA_CONFERENCE_LEAGUE_QUALIFYING,
  IN_RELEGATION,
  IN_PROMOTION,
  IN_PLAY_OFF,
  IN_PLAY_OUT,
];
// @ts-ignore
export const getQualificationMap: Record<
  UEFACompetitionQualification | CompetitionClassification,
  CompetitionClassification
> = {
  [UEFA_CHAMPIONS_LEAGUE]: CONTINENTAL_CUP_MAIN,
  [UEFA_CHAMPIONS_LEAGUE_QUALIFYING]: CONTINENTAL_CUP_MAIN_PLAY_OFF,
  [UEFA_EUROPA_LEAGUE]: CONTINENTAL_CUP_MINOR,
  [UEFA_EUROPA_LEAGUE_QUALIFYING]: CONTINENTAL_CUP_MINOR_PLAY_OFF,
  [UEFA_CONFERENCE_LEAGUE]: CONTINENTAL_CUP_THIRD,
  [UEFA_CONFERENCE_LEAGUE_QUALIFYING]: CONTINENTAL_CUP_THIRD_PLAY_OFF,
  [IN_PROMOTION]: PROMOTION,
  [IN_PLAY_OFF]: PROMOTION_PLAY_OFF,
  [IN_RELEGATION]: RELEGATION,
  [IN_PLAY_OUT]: RELEGATION_PLAY_OUT,
  // FIXME LC 2023-06-22: must CHECK if following VALUS are CORRECT!
  [CONTINENTAL_CUP_MAIN]: CONTINENTAL_CUP_MAIN,
  [CONTINENTAL_CUP_MAIN_PLAY_OFF]: CONTINENTAL_CUP_MAIN_PLAY_OFF,
  [CONTINENTAL_CUP_MINOR]: CONTINENTAL_CUP_MINOR,
  [CONTINENTAL_CUP_MINOR_PLAY_OFF]: CONTINENTAL_CUP_MINOR_PLAY_OFF,
  [CONTINENTAL_CUP_THIRD]: CONTINENTAL_CUP_THIRD,
  [CONTINENTAL_CUP_THIRD_PLAY_OFF]: CONTINENTAL_CUP_THIRD_PLAY_OFF,
  [PROMOTION]: PROMOTION,
  [PROMOTION_PLAY_OFF]: PROMOTION_PLAY_OFF,
  [RELEGATION]: RELEGATION,
  [RELEGATION_PLAY_OUT]: RELEGATION_PLAY_OUT,
};

export const getClassificationByUEFACompetitionQualification = (
  qualification: UEFACompetitionQualification | CompetitionClassification
): CompetitionClassification => getQualificationMap[qualification] || qualification;
